import { useGetActualCurrencyOneInch } from 'src/hooks/useGetActualCurrencyOneInch'

export const useConvertCurrency = () => {
  const { data: currencyInfo, isLoading } = useGetActualCurrencyOneInch()

  const dataCurrency: Record<string, number> = currencyInfo?.['1inch'] || {}

  const convertCurrency = (
    amount: number,
    from: string,
    to: string,
  ): number => {
    const rateFrom = Number(dataCurrency[from] ?? 0)
    const rateTo = Number(dataCurrency[to] ?? 0)

    if (!rateFrom || !rateTo) return 0

    return (amount / rateFrom) * rateTo
  }

  return {
    date: currencyInfo?.date || '',
    isLoading,
    dataCurrency,
    convertCurrency,
  }
}
